export function LoadingPage({ message = "Loading..." }: { message?: string }) {
  return (
    <div className="flex h-screen flex-col items-center justify-center">
      <div className="flex h-full flex-col items-center justify-center gap-2 p-16">
        <div
          className={`text-primary-foreground flex size-16 justify-center bg-[url("/images/loader-animated-dark.svg")] bg-no-repeat dark:bg-[url("/images/loader-animated.svg")]`}
        />
        <span>{message}</span>
      </div>
    </div>
  );
}
